import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "../../../util/getCustomColor";

export const Required = styled("span")(() => ({
  color: "#F04438",
  fontFamily: "Manrope",
  fontSize: 22,
  fontWeight: 600,
  lineHeight: "28px",
}));

const styles = (viewMode: boolean) =>
  makeStyles(() => ({
    container: {
      margin: viewMode ? "10px 0" : "25px 0 20px 0",
      width: "100%",
    },
    hr: {
      margin: "20px 0",
    },
    mainDiv: {
      borderRadius: "12px",
      backgroundColor: getBrandCustom("headerBackgroundColor", "#EDF5FB"),
      padding: viewMode ? 21 : "16px",
    },
    arrowAngle: {
      padding: 0,
      "&:hover": {
        backgroundColor: "transparent",
        borderRadius: "none",
      },
    },
    labelAddress: {
      cursor: "pointer",
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "18px",
      color: "#465869",
      marginBottom: 0,
      textTransform: "capitalize",
    },
    addressForm: {
      padding: "1.5rem 0",
    },
    infoIcons: {
      display: "flex",
      alignItems: "center",
      gap: "0 40px",
      "& p": {
        margin: "0",
        gap: "0",
      },
    },
    iconWhitespace: {
      background: "#FAFDFF",
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      "& svg": {
        height: "inherit",
        width: "20px",
        color: "#98A2B3",
      },
    },
    labelCustomerOrAddress: {
      marginLeft: "16px",
      color: "#667085",
      fontFamily: "Manrope",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "24px",
    },
    titleAddressOnView: {
      font: "700 18px/18px Manrope",
      color: "#465869",
      marginBottom: "0px !important",
    },
    mb16: {
      marginBottom: 16,
    },
    mt3: {
      marginTop: 3,
    },
    titleContainer: {
      cursor: "pointer",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    titleAsterisk: {
      color: "#F04438",
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: "28px",
    },
    iconWrapper: {
      display: "flex",
      alignItems: "center",

      backgroundColor: "#FAFDFF",
      borderRadius: "20px",
      height: "40px",
      padding: "10px",
      width: "40px",
      "& svg": {
        color: "#98A2B3",
      },
    },
    infosLetterCSS: {
      color: "#667085",
      fontFamily: "Manrope",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
    },
  }));

export const ViewModeTitle = styled("h5")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const ViewModeDivider = styled("hr")(() => ({
  backgroundColor: "#E4E7EC",
  height: "1px",
  margin: "0 0 16px",
  width: "100%",
  border: "0px",
}));

export const InfoWrapper = styled(Grid)(() => ({
  alignItems: "center",
  display: "flex",
  gap: "0 16px",

  overflow: "hidden",
  textOverflow: "ellipsis",
  whitesSpace: "nowrap",
  width: "100%",

  "& span": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whitesSpace: "nowrap",
  },
}));

export const ContactInfoWrapper = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  flexWrap: "wrap",

  color: "#667085",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "24px",
  marginBottom: "16px",
  padding: "0px !important",

  "@media (min-width: 600px)": {
    flexDirection: "row",
  },

  "@media (min-width: 1090px)": {
    flexWrap: "nowrap",
  },
}));

export const SectionWrapper = styled(Grid)(() => ({
  padding: "16px 10px 0 !important",
}));

export const ContactMapInfoWrapper = styled(ContactInfoWrapper)(() => ({
  marginBottom: "8px",
}));

export default styles;
